var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M26.426 17.059l-5.056-5.297-5.748-.1-4.875 2.826-.793 4.267-.087 5.374 7.697 5.43c.436-6.194 3.302-10.073 8.862-12.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M17.461 29.647c-4.364-.602-7.726-4.348-7.726-8.874 0-4.945 4.013-8.959 8.964-8.959a8.963 8.963 0 018.127 5.187"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M54.576 63.648h-41.78a.85.85 0 01-.698-.371.869.869 0 01-.097-.791c1.457-3.345 4.265-6.555 7.93-8.93l.044-.028c3.657-2.366 8.178-3.896 13.07-3.896.116 0 .336-.01.619-.01.247 0 .565.01.671.01 4.91 0 9.44 1.543 13.115 3.924l.044.028c3.647 2.372 6.429 5.57 7.886 8.902a.869.869 0 01-.097.79.855.855 0 01-.707.372z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M33.698 43.554c-6.856 0-12.41-5.55-12.41-12.401 0-6.852 5.554-12.401 12.41-12.401 6.855 0 12.408 5.55 12.408 12.4 0 6.852-5.553 12.402-12.408 12.402z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M22.595 43.786H2.888c-.198 0-.39-.1-.504-.269a.628.628 0 01-.07-.571c1.052-2.417 3.08-4.735 5.728-6.451l.032-.02c2.431-1.57 5.385-2.631 8.587-2.793"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M68.036 47.904c2.103 1.832 3.723 3.98 4.691 6.195a.781.781 0 01-.087.71.768.768 0 01-.635.335H55.94m-15.073-9.07l.04-.026c3.286-2.126 7.35-3.501 11.747-3.501.103 0 .301-.01.555-.01.223 0 .508.01.604.01 1.603 0 3.159.183 4.65.518"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M45.576 17.838c2-1.888 4.691-3.047 7.66-3.047 6.151 0 11.152 4.995 11.152 11.147s-5 11.146-11.152 11.146c-1.151 0-2.262-.175-3.31-.498"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.3ca9b08e780430683a992172c0ae294b.svg";
export { ForwardRef as ReactComponent };